module.exports = __webpack_public_path__ + "static/media/mud_weather.858f9b34.jpg";